import {Map} from 'immutable';
import Audio from './Audio.react';

export default Map({
  renderer: Audio,
  type: 'audio',
  label: 'Audio'
});
